module.exports = __webpack_public_path__ + "static/media/Golds-Gym.e6ef36fc.svg";